<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>{{ title }}</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <div class="flex flex-col gap-4">
        <Input v-model="name" size="xl" :label="label" :disabled="loading" />
        <Alert v-if="error?.message" variant="error" :icon="AlertIcon">
          {{ error.message }}
        </Alert>
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, Alert, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon, AlertIcon } from '@dacr/icons'
import type { CopyrightOwnerNew } from '@/shared/graphql/legacy/generated'
import { useEditCopyrightOwner } from './useEditCopyrightOwner'

const { close } = useSheet()

const props = defineProps<{
  owner: CopyrightOwnerNew
}>()

const { name, title, label, loading, error, canSave, save } =
  useEditCopyrightOwner(props.owner)

const handleSave = async () => {
  if (await save()) close()
}
</script>
